import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const FooterWrapper = styled('section')`
  display: flex;
  flex: 1 0 auto;
`

const FooterContainer = styled('div')`
  ${flexCenter}

  align-self: flex-end;
  flex-direction: column;
  height: auto;
  margin-top: 80px;
  margin-bottom: 48px;

  > span {
    font-size: 0.75rem;
    font-weight: 300;
  }

  ${mediaQuery('laptop')} {
    margin-bottom: 24px;

    #case-level-navbar ~ ${FooterWrapper} & {
      margin-bottom: calc(24px + var(--case-nav-bar-height));
    }
  }
`

export { FooterContainer, FooterWrapper }
